(function ($) {
  var nextArrowSVG = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="59.5" y="0.5" width="59" height="59" rx="11.5" transform="rotate(90 59.5 0.5)" stroke="black"/><path d="M23 44L37 30L23 16" stroke="black" stroke-width="2"/></svg>';
  var prevArrowSVG = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="59.5" width="59" height="59" rx="11.5" transform="rotate(-90 0.5 59.5)" stroke="black"/><path d="M37 16L23 30L37 44" stroke="black" stroke-width="2"/></svg>';
  $(function () {
      var productFeatureSlider = $('.product-features__images-wrapper').slick({
        dots: false,
        prevArrow: '<span class="slick-arrow slick-prev">'+ prevArrowSVG +'</span>',
        nextArrow: '<span class="slick-arrow slick-next">'+ nextArrowSVG +'</span>',
        adaptiveHeight: true
      });


      $('.product-features__content-item').on('click', function(){
        $('.product-features__content-item').removeClass('active');

        $(this).addClass('active');
        
        var gotoIndex = $(this).attr('data-image-target');
        productFeatureSlider[0].slick.slickGoTo(gotoIndex);
      });


      productFeatureSlider.on('afterChange', function(event, slick, currentSlide){
        $('.product-features__content-item').removeClass('active');
        $('.product-features__content-item[data-image-target="'+ currentSlide +'"]').addClass('active');
      });


      $('#product-feature-showmore').on('click', function(e){
          e.preventDefault();

          $(this).hide();

          $('.product-features__content-item').show();
      });
    });
})(jQuery);